import React from 'react';
import { Link } from '@this/shared/ui/navigations/link';

interface Props {
  prevTripId: number | null;
  nextTripId: number | null;
  position: number;
  total: number;
}

const tripPath = (tripId: number | null) => (tripId ? `/application/in_advance/${tripId}` : undefined);

const UnapprovedApplicationNavigation: React.FC<Props> = ({ prevTripId, nextTripId, position, total }) => {
  const counter = `（${position}件目／残${total}件）`;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
      <Link size="small" disabled={!prevTripId} href={tripPath(prevTripId)}>
        {`< 前の未承認の申請${counter}`}
      </Link>
      <Link size="small" disabled={!nextTripId} href={tripPath(nextTripId)}>
        {`次の未承認の申請${counter} >`}
      </Link>
    </div>
  );
};

export default UnapprovedApplicationNavigation;
